import { BackgroundProps } from './types';
import { StyledBackground } from './style';
import { useIsDesktop, useIsLandscape } from 'utils';

export const Background: React.FC<BackgroundProps> = ({
  backgroundImageMobile,
  backgroundImageDesktop,
  backgroundPosition = 'center top',
  backgroundSize = 'cover',
  backgroundColor = '',
  width = '100vw',
  height = '100vh',
  minHeight = 'unset',
  position = 'static',
  isStore = false,
  children,
}) => {
  const isLandscape = useIsLandscape();
  const isDesktop = useIsDesktop();

  return (
    <StyledBackground
      backgroundImage={
        isDesktop || isLandscape
          ? backgroundImageDesktop
          : backgroundImageMobile
      }
      backgroundColor={backgroundColor}
      backgroundPosition={backgroundPosition}
      backgroundSize={backgroundSize}
      width={width}
      height={height}
      minHeight={minHeight}
      position={position}
      isStore={isStore}
      className={'store-background'}
    >
      {children}
    </StyledBackground>
  );
};
